import { Card, CardActions, CardContent, Grid, Theme, Typography, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import views, { View } from "../../data/views.data";
import React, { useContext, useEffect } from "react";
import VspPortalContext from "../../store/VspPortalContext";
import { CheckHealth } from "../Maintenance/components/CheckHealth";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";

const cardSx = {
  
  cursor: 'pointer',
  textDecoration:'none',
  width:'250px',
  '&:hover': {
    boxShadow: 30,
    transition: 'transform .3s cubic-bezier(.2,.9,.3,1.3)',
    transform: 'scale(1.04)'
  },
  // border: '1px solid white'
  // boxShadow: '0px 2px 1px -1px rgba(255,255,255,0.2),0px 1px 1px 0px rgba(255,255,255,0.14),0px 1px 3px 0px rgba(255,255,255,0.12)'
  // boxShadow: 'rgba(255, 255, 255, 0.85) 1.95px 1.95px 2.6px'
  // boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px'

};

export const Home: React.FC = ( ) => {

  const { state } = useContext( VspPortalContext );
  const theme = useTheme( );

  const cardActionsSx = {
    
    color: theme.palette.text.primary
    , display: 'block'
    , padding:'20px'
    , marginLeft: 'auto'
    , marginRight:'auto'

  };

  
  const cards = views.filter( ( view: View ) => view.userGroups.filter( e => state.userGroups.includes ( e ) ).length > 0 ).map( (view: View) => 
    
    <Card sx={cardSx} component={NavLink} to={view.path} key={view.index}>
        <CardContent sx={{ background:'#f77f00', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {
            // https://stackoverflow.com/questions/58878858/how-do-i-style-a-material-ui-icon-which-was-passed-as-prop
            React.cloneElement( view.icon, {
              style:{color:'white', fontSize:'50px'}
            })

          }
        </CardContent>
        <CardActions>
          <Typography sx={ cardActionsSx } >
            {view.text}
          </Typography>
        </CardActions>
    </Card>
    
  );

  return (
    
    <>

      <CheckHealth />

      <Grid 
        container
        spacing={0}
        direction="row"
        alignItems="center"
        justifyContent="center"
        style={{ height: 'calc(100vh - 48px)', backgroundColor: theme.palette.background.default }}
        gap={2}
      >
      
        {cards}

      </Grid>

    </>

  );

};